export default __webpack_public_path__ + "static/media/10.74d07e81.jpg";